import { render } from "./Eyebrow.vue?vue&type=template&id=725c45d4&scoped=true"
const script = {}

import "./Eyebrow.vue?vue&type=style&index=0&id=725c45d4&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-725c45d4"]])

export default __exports__